import { createContext } from "react";
import { noop } from "lodash";
import { FinancialDocument } from "../../common/types/financialDocument";
import { IntegrationAccount } from "../../common/types/integrationAccount";
import { ImporterDocumentRow } from "./types";

export interface PreviewedRow {
    id: string;
    financialDocument: FinancialDocument;
    integrationAccount: IntegrationAccount;
}

interface ImporterContextValue {
    documentRows: ImporterDocumentRow[];
    previewedRow?: PreviewedRow;
    setPreviewedRow: (row: PreviewedRow | undefined) => void;
    addDocumentRow: (documentRow: ImporterDocumentRow) => void;
    updateDocumentRow: (
        id: string,
        documentRow: Partial<Omit<ImporterDocumentRow, "id">>,
    ) => void;
    removeDocumentRow: (documentRow: ImporterDocumentRow) => void;
}

export const ImporterContext = createContext<ImporterContextValue>({
    documentRows: [],
    setPreviewedRow: noop,
    addDocumentRow: noop,
    updateDocumentRow: noop,
    removeDocumentRow: noop,
});
